import React from 'react';
import { Divider } from 'antd';
import { ChannelField } from './AlarmDefaultFields/AlarmChannelField/ChannelField';
import { DescriptionField } from './AlarmDefaultFields/AlarmDescriptionField/DescriptionField';
import { TriggerTypeField } from './AlarmDefaultFields/AlarmTriggerTypeField/TriggerTypeField';
import { AlarmTypes } from './AlarmTypes/AlarmTypes';

export function CreateAlarmStepTwo() {
  return (
    <>
      <DescriptionField />
      <TriggerTypeField />
      <AlarmTypes />
      <Divider />
      <ChannelField />
    </>
  );
}
